/* eslint-disable no-console */
import {
  getSS,
  setSS,
  getLS,
  setLS,
  getHashCode,
  getQuery,
  EventPublisher,
  TimeoutPromise,
} from './utils';

/**
 * AB Test模块
 */
const ABTest = class {
  constructor($config, $ctx) {
    this.$config = $config;
    this.$ctx = $ctx;
    this.deviceID = $ctx.deviceID;
    this.abConfig = {
      subscriber: new EventPublisher(),
      status: 0, // 0未加载，1加载中，2已加载
      timeout: 5e3,
      value: null,
    };
    this.KEY_ABRECORD = 'ABRecord';

    // 初始化ab使用记录
    this.abRecord = getLS(this.KEY_ABRECORD) ?? {};
  }

  /**
   * 通过实验ID获取实验AB值(会记录使用过的AB到LS)
   * @param {*} id
   */
  async getAB(id) {
    // 先走MOCK
    let val = getQuery(`mockab_${id}`);
    if (val) {
      setSS(`mockab_${id}`, val);
    } else {
      val = getSS(`mockab_${id}`);
    }

    if (!val) {
      // 读取配置进行计算
      const allConfig = await this.$GetABConfig();
      val = this.$CalcAB(id, allConfig[id]);
    }

    // 保存至已使用存储
    if (val && this.abRecord[id] !== val) {
      this.abRecord[id] = val;
      setLS(this.KEY_ABRECORD, this.abRecord);
    }

    return val;
  }

  /**
   * 获取使用过的AB实验结果
   */
  getABRecord() {
    return this.abRecord;
  }

  /**
   * 获取实验配置
   */
  $GetABConfig() {
    switch (this.abConfig.status) {
      default:
      case 0:
        return new Promise(resolve => {
          this.abConfig.subscriber.on('load', resolve);
          this.abConfig.status = 1;
          this.$LoadABConfig().then(abConfig => {
            this.abConfig.value = abConfig;
            this.abConfig.status = 2;
            // 加载完配置先清理下线的AB数据
            this.$CleanOfflineABRecord();
            this.abConfig.subscriber.emit('load', this.abConfig.value);
          });
        });
      case 1: // 加载中
        return new Promise(resolve => {
          this.abConfig.subscriber.on('load', resolve);
        });
      case 2: // 已加载
        return Promise.resolve(this.abConfig.value);
    }
  }

  /**
   * 加载AB配置
   */
  $LoadABConfig() {
    return new TimeoutPromise(resolve => {
      // 可实现为远程读取接口数据
      resolve(this.$config.abtest);
    }, this.abConfig.timeout).catch(error => {
      console.warn('load abtest config error', error);
      return {};
    });
  }

  /**
   * 根据指定的id和config计算AB值
   */
  $CalcAB(id, config) {
    if (!config) {
      console.warn(`abtest (${id}) no exp config`);
      return null;
    }

    if (config.times && config.times.length) {
      const tzTime = new Date().getTime();
      let seg = null;
      for (const time of config.times) {
        if (time && tzTime >= new Date(time.begin).getTime()
          && tzTime <= new Date(time.end).getTime()) {
          seg = time.seg;
          break;
        }
      }

      if (seg === null || seg.length === 0) {
        console.warn(`abtest (${id}) no seg`, config);
        return null;
      }

      const magic = this.$GetMagicNumber(id);
      let val = this.$SelectSegIndex(magic, seg);
      if (val >= 0 && val <= 25) {
        val = String.fromCharCode(val + 65);
        return val;
      }
      console.warn(`abtest (${id}) seg index error`, val, magic, config);
    } else {
      console.warn(`abtest (${id}) time error`, config);
    }
    return null;
  }

  /**
   * 计算出该设备针对该实验的比对值[0, 0.9999]
   */
  $GetMagicNumber(id) {
    return (getHashCode(`${this.deviceID}${id}`) % 10000) / 10000;
  }

  /**
   * 返回命中分桶的序号
   * @param {*} magic
   * @param {*} seg
   */
  // eslint-disable-next-line class-methods-use-this
  $SelectSegIndex(magic, seg) {
    const sum = seg.reduce((prev, next) => prev + next);
    const threshold = sum * magic;
    for (let i = 0, p = 0; i < seg.length; i += 1) {
      p += seg[i];
      if (p > threshold) {
        return i;
      }
    }
    return -1;
  }

  /**
   * 清理已经不再使用的AB缓存记录
   */
  $CleanOfflineABRecord() {
    if (!this.abConfig.value) return;
    const onlineABRecord = {};
    for (const id in this.abRecord) {
      if (id in this.abConfig.value) {
        onlineABRecord[id] = this.abRecord[id];
      }
    }
    this.abRecord = onlineABRecord;
    setLS(this.KEY_ABRECORD, this.abRecord);
  }
};

export default ABTest;
